<template>
  <v-toolbar flat app color="white">
    <v-toolbar-side-icon
      v-if="user"
      class="grey--text"
      @click="$emit('update:drawer', !drawer)"
    />
    <v-spacer />
    <v-btn
      v-if="user && (user.roles || []).includes('global-admin')"
      icon
      :to="'/admin'"
    >
      <v-avatar size="28">
        <Icon name="gear" />
      </v-avatar>
    </v-btn>
    <v-menu
      :close-on-click="true"
      :close-on-content-click="false"
      bottom
      left
      offset-y
      nudge-bottom="5"
    >
      <template v-slot:activator="{ on }">
        <v-badge
          :value="count > 0 ? true : false"
          class="notif-number"
          color="secondary"
          overlap
        >
          <template v-slot:badge>
            <span>{{ count }}</span>
          </template>
          <v-btn v-on="on" small icon>
            <v-avatar size="28">
              <Icon size="24px" name="alarm" />
            </v-avatar>
          </v-btn>
        </v-badge>
      </template>

      <NotificationList :count.sync="count" v-if="user" />
    </v-menu>
    <v-divider inset class="ml-3 mr-3" vertical />
    <div id="user-menu" class="user-menu relative">
      <v-menu
        :close-on-click="true"
        absolute
        attach="user-menu"
        :close-on-content-click="true"
        bottom
        left
        offset-y
        nudge-bottom="45"
        nudge-right="45"
      >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-avatar size="32">
              <img v-if="picture" class="text-lg-center" :src="picture" />
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile :to="'/profile'">
            <Icon name="person" />
            <span class="mx-2">Perfil</span>
          </v-list-tile>

          <v-list-tile @click="close">
            <Icon name="logout" />
            <span class="mx-2">Logout</span>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NotificationList from '@/views/Notifications/NotificationList'
import Icon from '@/components/icons/Icons.vue'
export default {
  props: {
    drawer: { type: Boolean }
  },
  components: {
    NotificationList,
    Icon
  },
  data() {
    return {
      count: 0
    }
  },
  computed: {
    ...mapGetters(['authenticated', 'user', 'profile', 'username', 'picture']),
    userDisplayName() {
      return this.$store.getters.userDisplayName
    },
    userSpeciality() {
      return this.$store.getters.specialty
    }
  },
  methods: {
    ...mapActions(['logout']),
    close() {
      this.$crisp.push(['do', 'session:reset'])
      this.logout()
    }
  }
}
</script>

<style>
.notif-number .v-badge__badge {
  top: -2px !important;
  right: -1px !important;
  border: 2px solid #fff !important;
}
.notif-number .v-badge__badge span {
  position: relative;
  top: 0px;
  font-weight: bold;
  font-size: 10px;
}
</style>
